<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Empresa</div>
            <div class="subTitulo">
              Visualize aqui informações da sua empresa.
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>
      <div class="form">
        <form action="">
          <b-tabs content-class="mt-3">
            <b-tab title="Dados Pessoais" active>
              <div>
                <div
                  class="h-100 d-flex align-items-center justify-content-center"
                >
                  <b-avatar
                    v-bind:src="'data:image/jpeg;base64,' + empresa.logo"
                    button
                    badge-offset="-2px"
                    size="6rem"
                    @click="$bvModal.show('modal-upload')"
                  >
                    <template #badge
                      ><b-icon icon="camera"></b-icon
                    ></template>
                  </b-avatar>
                </div>

                <b-form-group label="Nome" label-for="label-1">
                  <b-form-input
                    id="label-1"
                    type="text"
                    placeholder="Digite Aqui o Nome"
                    v-model="empresa.nome"
                    required
                    v-no-autocomplete
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="CPF/CNPJ" label-for="label-2">
                  <b-form-input
                    id="label-2"
                    type="text"
                    placeholder="Digite Aqui o CPF ou CNPJ"
                    v-model="empresa.cnpj"
                    v-mask="['###.###.###-##', '##.###.###/####-##']"
                    required
                    v-no-autocomplete
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="E-mail" label-for="label-3">
                  <b-form-input
                    id="label-3"
                    type="email"
                    placeholder="Digite Aqui o E-mail"
                    v-model="empresa.email"
                    required
                    v-no-autocomplete
                  ></b-form-input>
                </b-form-group>

                <b-form-group label="Telefone" label-for="label-4">
                  <b-form-input
                    id="label-4"
                    type="text"
                    placeholder="Digite Aqui o Telefone"
                    v-model="empresa.telefone"
                    v-mask="['(##) ####-####', '(##) #####-####']"
                    required
                    v-no-autocomplete
                  ></b-form-input>
                </b-form-group>
              </div>
            </b-tab>

            <!-- ENDEREÇO -->

            <b-tab title="Dados do  Endereço">
              <b-form-group label="Endereço" label-for="label-5">
                <b-form-input
                  id="label-5"
                  type="text"
                  placeholder="Digite Aqui o Endereço"
                  v-model="empresa.endereco"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group label="CEP" label-for="label-6">
                <b-form-input
                  id="label-6"
                  type="text"
                  placeholder="Digite Aqui o CEP"
                  v-model="empresa.cep"
                  v-mask="['#####-###']"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Estado" label-for="label-7">
                <v-select
                  class="style-select"
                  label="nome"
                  :options="estados"
                  :reduce="(item) => item.id_estado"
                  v-model="empresa.id_estado"
                  :dense="true"
                  @input="$forceUpdate()"
                ></v-select>
              </b-form-group>
              <b-form-group label="Cidade" label-for="label-8">
                <v-select
                  class="style-select"
                  label="nome"
                  :options="cidades"
                  :reduce="(item) => item.id_municipio"
                  v-model="empresa.id_municipio"
                  :dense="true"
                  @input="$forceUpdate()"
                ></v-select>
              </b-form-group>
            </b-tab>
            <!-- 
              ABA com input de Configuração      
            -->
            <b-tab title="Configurações">
              <b-form-group label="Login" label-for="label-9">
                <b-form-input
                  id="label-9"
                  type="text"
                  placeholder="Digite o Login"
                  v-model="empresa.login"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Senha" label-for="label-10">
                <b-form-input
                  id="label-10"
                  type="password"
                  placeholder="Digite uma Senha"
                  v-model="empresa.senha"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Siga" label-for="label-13">
                <b-form-input
                  id="label-13"
                  type="text"
                  placeholder="Digite SIGA"
                  v-model="empresa.registro_siga"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="fieldset-1"
                description=""
                label="Configurações adicionais"
                label-for="input-3"
              >
                <b-form-checkbox
                  disabled
                  v-model="empresa.is_digial_signature"
                  switch
                  >Assinatura Digital</b-form-checkbox
                >
                <b-form-checkbox disabled v-model="empresa.is_api" switch
                  >API de Integração</b-form-checkbox
                >
              </b-form-group>
            </b-tab>

            <!--
                 ABA de tokens
             -->

            <b-tab title="Tokens">
              <b-form-group label="Secret ID" label-for="label-14">
                <b-form-input
                  id="label-14"
                  type="text"
                  v-model="empresa.secret_id"
                  disabled
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Client ID" label-for="label-14">
                <b-form-input
                  id="label-14"
                  type="text"
                  v-model="empresa.client_id"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-tab>
          </b-tabs>
          <b-btn variant="primary" @click="saveOrUpdate">Salvar</b-btn>
        </form>
      </div>
    </div>
    <b-modal
      id="modal-upload"
      size="lg"
      title="Upload Logo"
      title-class="font-18"
      @hide="init()"
    >
      <uploadLogo></uploadLogo>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="$bvModal.hide('modal-upload')"
          >Sair</b-button
        >
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import uploadLogo from '@/src/components/upload-logo-empresa.vue'

import empresaService from '@/src/services/empresa_sistema'
import estadoServices from '@/src/services/estado'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mask } from 'vue-the-mask'

export default {
  components: { Layout, Loading, uploadLogo },
  directives: { mask },
  data() {
    return {
      isLoading: false,
      empresa: {},
      estados: [],
      cidades: [],
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    'empresa.id_estado'() {
      this.listaCidade(this.empresa.id_estado)
    },
  },
  methods: {
    init() {
      this.findEmpresa()
      this.listaEstados()
    },
    listaEstados() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      estadoServices.lista(token).then((resposta) => {
        this.estados = resposta.data.estados
        this.isLoading = false
      })
    },
    listaCidade(a) {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      estadoServices.listaCidades(token, a).then((resposta) => {
        this.cidades = resposta.data.cidades
        this.isLoading = false
      })
    },
    findEmpresa() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = true
      empresaService.listarEmpresa(token).then((resposta) => {
        this.empresa = resposta.data.empresa[0]
        this.isLoading = false
      })
    },
    saveOrUpdate() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token

      if (this.empresa.id_empresa_sistema) {
        empresaService
          .atualizarEmpresa(token, this.empresa)
          .then((resposta) => {
            this.isLoading = false
            this.$bvToast.toast('Dados da empresa atualizado!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          })
          .catch((erro) => {
            this.isLoading = false
            this.$bvToast.toast(erro.response.data.message, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          })
        return
      }
      empresaService
        .salvarEmpresa(token, this.empresa)
        .then((resposta) => {
          this.isLoading = false
          this.$bvToast.toast('Configuração salva!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(erro.response.data.message, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
    },
  },
}
</script>
<style lang="scss">
.bloco {
  color: #4b4b5a;
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-relatorio {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    margin-top: 39px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
  }
}
.form form {
  min-height: 400px;
}
.form-control:disabled,
.form-control[readonly] {
  background: #dddddd;
}
</style>
